import { MESSAGES } from "../users.constants";

const EmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center p-8 border rounded-md bg-gray-50">
      <p className="text-gray-500 my-4">{MESSAGES.EMPTY}</p>
    </div>
  );
};

export default EmptyState;
